import { IElementToSimpleSapElementMapperFactory } from './IElementToSimpleSapElementMapperFactory';
import { ElementToSimpleSapElementMapperFactory } from './chestFurniture/elementToSimpleSapElementMapperFactory';
import store from '@/store';
import { ProductType } from '@/store/modules/product';
import { DeskElementToSimpleSapElementMapperFactory } from './desk/deskElementToSimpleSapElementMapperFactory';
import { DressingElementToSimpleSapElementMapperFactory } from './dressing/dressingElementToSimpleSapElementMapperFactory';
import { TableElementToSimpleSapElementMapperFactory } from './table/tableElementToSimpleSapElementMapperFactory';
import { BedsideTableToSimpleSapElementMapperFactory } from './bedsideTable/bedsideTableElementToSimpleSapElementMapperFactory';
import { CtrElementToSimpleSapElementMApperFactory } from './coffeeTableRectangle/ctrElementToSimpleSapElementMapperFactory';
import { CtElementToSimpleSapElementMapperFactory } from './coffeeTable/ctElementToSimpleSapElementMapperFactory';
import { BedElementToSimpleSapElementMapperFactory } from './bed/bedElementToSimpleSapElementMapperFactory';

export class ElementToSimpleSapElementMapperAbstractFactory {

    private chestFurniture: IElementToSimpleSapElementMapperFactory;
    private desk: IElementToSimpleSapElementMapperFactory;
    private dressing: IElementToSimpleSapElementMapperFactory;
    private table: IElementToSimpleSapElementMapperFactory;
    private bedsideTable: IElementToSimpleSapElementMapperFactory;
    private coffeeTableRectangle: IElementToSimpleSapElementMapperFactory;
    private coffeeTable: IElementToSimpleSapElementMapperFactory;
    private bed: IElementToSimpleSapElementMapperFactory;

    public get(): IElementToSimpleSapElementMapperFactory {
        const t: ProductType = store.getters.product.type;
        if (t === ProductType.CHEST_FURNITURE) {
            return this._chestFurniture;
        }
        if (t === ProductType.DESK) {
            return this._desk;
        }
        if (t === ProductType.DRESSING) {
            return this._dressing;
        }
        if (t === ProductType.TABLE) {
            return this._table;
        }
        if (t === ProductType.BEDSIDE_TABLE) {
            return this._bedsideTable;
        }
        if (t === ProductType.COFFEE_TABLE_RECTANGLE) {
            return this._coffeeTableRectangle;
        }
        if (t === ProductType.COFFEE_TABLE) {
            return this._coffeeTable;
        }
        if (t === ProductType.BED) {
            return this._bed;
        }
    }

    private get _chestFurniture() {
        if (!this.chestFurniture) {
            this.chestFurniture = new ElementToSimpleSapElementMapperFactory();
        }
        return this.chestFurniture;
    }

    private get _desk() {
        if (!this.desk) {
            this.desk = new DeskElementToSimpleSapElementMapperFactory();
        }
        return this.desk;
    }

    private get _dressing() {
        if (!this.dressing) {
            this.dressing = new DressingElementToSimpleSapElementMapperFactory();
        }
        return this.dressing;
    }

    private get _table() {
        if (!this.table) {
            this.table = new TableElementToSimpleSapElementMapperFactory();
        }
        return this.table;
    }

    private get _bedsideTable() {
        if (!this.bedsideTable) {
            this.bedsideTable = new BedsideTableToSimpleSapElementMapperFactory();
        }
        return this.bedsideTable;
    }

    private get _coffeeTableRectangle() {
        if (!this.coffeeTableRectangle) {
            this.coffeeTableRectangle = new CtrElementToSimpleSapElementMApperFactory();
        }
        return this.coffeeTableRectangle;
    }

    private get _coffeeTable() {
        if (!this.coffeeTable) {
            this.coffeeTable = new CtElementToSimpleSapElementMapperFactory();
        }
        return this.coffeeTable;
    }

    private get _bed() {
        if (!this.bed) {
            this.bed = new BedElementToSimpleSapElementMapperFactory();
        }
        return this.bed;
    }
}
